import React, {Component} from 'react';
import lpevents from '../tracking/lpevents';
import { onboardingData } from '../constants/onboardingData';
import chevronForwardIcon from "../styles/img/onboarding/chevron-forward.svg";
import chevronBackIcon from "../styles/img/onboarding/chevron-back.svg";

class OnboardingModal extends Component {
  contractOnboardingData = onboardingData[this.props.contractMetaId];
  localStepNumber = JSON.parse(localStorage.getItem("onboardingCoursierStep")) || null;
  state = {
    stepNumber: this.localStepNumber || 1
  };

  goToNextStep = () => {
    const { stepNumber } = this.state;
    this.setState({ stepNumber: stepNumber + 1 }, () =>
      localStorage.setItem("onboardingCoursierStep", this.state.stepNumber)
    );
  };

  goToPreviousStep = () => {
    const { stepNumber } = this.state;
    this.setState({ stepNumber: stepNumber - 1 }, () =>
      localStorage.setItem("onboardingCoursierStep", this.state.stepNumber)
    );
  };

  componentDidMount() {
    const { stepNumber } = this.state;
    const { title } = this.contractOnboardingData[`step_${stepNumber}`];
    lpevents.trackMix("coursierOnboardingNav", {
      onboardingScreen: title
    });
  }
  
  componentDidUpdate(prevProps, prevState) {
    const { stepNumber } = this.state;
    const { title } = this.contractOnboardingData[`step_${stepNumber}`];
    
    if (prevState.stepNumber !== stepNumber) {
      lpevents.trackMix("coursierOnboardingNav", {
        onboardingScreen: title
      });
    }
  }
  
  render() {
    const { stepNumber } = this.state;
    
    const { htmlTitle, content, img } = this.contractOnboardingData[
      `step_${stepNumber}`
    ];
    const { totalSteps } = this.contractOnboardingData;
    const { closeOnboardingModal } = this.props;
    const isFirstStep = stepNumber === 1;
    const isLastStep = stepNumber === totalSteps;

    return (
      <div className="onboardingModal-container">
        <div className="onboardingModal-content-container">
          <img className="onboardingModal-img" src={img} />
          <h2
            className="onboardingModal-content-title"
            dangerouslySetInnerHTML={{ __html: htmlTitle }}
          ></h2>
          <p className="onboardingModal-content-text">{content}</p>
          <div className="onboardingModal-pagination-container">
            <div
              className={`onboardingModal-pagination-item ${
                stepNumber === 1 ? "isCurrentPage" : ""
              }`}
            />
            <div
              className={`onboardingModal-pagination-item ${
                stepNumber === 2 ? "isCurrentPage" : ""
              }`}
            />
            <div
              className={`onboardingModal-pagination-item ${
                stepNumber === 3 ? "isCurrentPage" : ""
              }`}
            />
          </div>
          <div className="onboardingModal-btn-container">
            {isLastStep ? (
              <button
                type="button"
                className="onboardingModal-btn onboardingModal-btn_primary"
                onClick={closeOnboardingModal}
              >
                C'est parti !
              </button>
            ) : (
              <button
                type="button"
                className="onboardingModal-btn onboardingModal-btn_primary"
                onClick={this.goToNextStep}
              >
                Suivant
                <img
                  className="onboardingModal-btn-icon"
                  src={chevronForwardIcon}
                  alt=""
                />
              </button>
            )}
            {!isFirstStep && (
              <button
                type="button"
                className="onboardingModal-btn"
                onClick={this.goToPreviousStep}
              >
                <img
                  className="onboardingModal-btn-icon"
                  src={chevronBackIcon}
                  alt=""
                />
                Précédent
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default OnboardingModal;


// WEBPACK FOOTER //
// ./src/components/OnboardingModal.js